import { ref, watch, type Ref } from 'vue'

/**
 * Returns a ref whose value is kept in sync with a URL query parameter.
 * When the value equals `defaultValue` (or is empty), the param is removed.
 * Uses replaceState so the browser history stack stays clean.
 */
export function useQueryParam<T extends string = string>(key: string, defaultValue: T): Ref<T> {
  const raw = new URLSearchParams(window.location.search).get(key)
  const value = ref((raw ?? defaultValue) as T) as Ref<T>

  watch(value, (v) => {
    const url = new URL(window.location.href)
    if (!v || v === defaultValue) {
      url.searchParams.delete(key)
    } else {
      url.searchParams.set(key, v)
    }
    history.replaceState(null, '', url.toString())
  })

  return value
}
